import React, {useEffect, useRef} from 'react'
import './ParentCanvas.scss';

const OFFSET_X = 0;
const OFFSET_Y = 18;

// draws lines connecting ParentARMBoxes to progress chart markers
export default function ParentCanvas(props) {
  const {progressChartRef, armBoxRefs} = props;

  const canvasRef = useRef(null)
  
  useEffect(() => {
    if (!progressChartRef.current) return;
    if (!armBoxRefs.current.BOY) return;

    const progressChart = progressChartRef.current.chart;
    const activitySeries = progressChart?.series?.find(series => series.name.includes('performance'));

    const {chartWidth, chartHeight, plotLeft, plotTop} = progressChart;

    // map activityId to coords (x,y) for each activity on progress chart
    const coordinateMap = {};
    for (const point of activitySeries.points) {
      const {activityId, plotX, plotY} = point;
      if (activityId) coordinateMap[activityId] = {
        x: plotX + plotLeft + OFFSET_X,
        y: plotY + plotTop + OFFSET_Y,
      };
    }

    // set canvas width/height to progress chart width/height
    const canvas = canvasRef.current
    canvas.width = chartWidth;
    canvas.height = chartHeight;

    // configure canvas context for drawing lines
    const ctx = canvas.getContext('2d')
    ctx.strokeStyle = '#888';
    ctx.lineWidth = 4;

    const windows = ['BOY', 'MOY', 'EOY'];
    for (const window of windows) {
      const armBoxRef = armBoxRefs.current[window];
      // skip if armBox is not visible
      if (!armBoxRef || armBoxRef.className.includes('hidden')) continue;
      const {width} = armBoxRef.getBoundingClientRect();
      const offsetLeft = armBoxRef.offsetLeft;
      const x1 = offsetLeft + width/2;
      const y1 = 0;

      const activityId = armBoxRef.id;

      const coordinate = coordinateMap[activityId]
      // skip if activity not present within progress chart
      if (!coordinate) {
        console.log('cannot draw line: activity not found', activityId)
        continue;
      }

      const {x: x2, y: y2} = coordinate;

      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
    }
  }, [progressChartRef, armBoxRefs]);
  
  return <canvas ref={canvasRef} className="parent-canvas" />
}
